var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tab" },
    [
      _c(
        "draggable",
        {
          staticClass: "fields",
          attrs: {
            group: `profile-tab-${_vm._uid}`,
            list: _vm.fields,
            "force-fallback": true,
            "ghost-class": "field-ghost",
          },
          on: { change: _vm.resortFields },
        },
        _vm._l(_vm.fields, function (field) {
          return _c(
            "div",
            {
              key: field.id,
              staticClass: "field",
              class: {
                "field--new-line": field.newLine,
              },
              attrs: {
                "data-size": _vm.getFieldSize(field),
                "data-type": _vm.getFieldType(field),
                "data-system": field.isSystem,
              },
            },
            [
              _c("div", { staticClass: "field__controls" }, [
                _c("div", { staticClass: "field__format" }),
                _c(
                  "div",
                  { staticClass: "field__actions" },
                  [
                    _c("c-button", {
                      directives: [
                        {
                          name: "b-popover",
                          rawName: "v-b-popover.html",
                          value: {
                            container: "#app",
                            trigger: "hover blur",
                            boundary: "window",
                            content: "Действия",
                            placement: "top",
                          },
                          expression:
                            "{\n              container: '#app',\n              trigger: 'hover blur',\n              boundary: 'window',\n              content: 'Действия',\n              placement: 'top',\n            }",
                          modifiers: { html: true },
                        },
                      ],
                      staticClass: "field__menu",
                      attrs: {
                        id: `field-actions-${field.id}`,
                        tabindex: "-1",
                        size: "iconic",
                        icon: "menu",
                      },
                    }),
                    _c("c-button", {
                      directives: [
                        {
                          name: "b-popover",
                          rawName: "v-b-popover.html",
                          value: {
                            container: "#app",
                            trigger: "hover blur",
                            boundary: "window",
                            content: "Отображать параметр с новой строки",
                            placement: "top",
                          },
                          expression:
                            "{\n              container: '#app',\n              trigger: 'hover blur',\n              boundary: 'window',\n              content: 'Отображать параметр с новой строки',\n              placement: 'top',\n            }",
                          modifiers: { html: true },
                        },
                      ],
                      staticClass: "field__new-line",
                      attrs: {
                        tabindex: "-1",
                        size: "iconic",
                        icon: "new-line",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setNewLine(field)
                        },
                      },
                    }),
                    _c("c-button", {
                      directives: [
                        {
                          name: "b-popover",
                          rawName: "v-b-popover.html",
                          value: {
                            container: "#app",
                            trigger: "hover blur",
                            boundary: "window",
                            content: "Переместить",
                            placement: "top",
                          },
                          expression:
                            "{\n              container: '#app',\n              trigger: 'hover blur',\n              boundary: 'window',\n              content: 'Переместить',\n              placement: 'top',\n            }",
                          modifiers: { html: true },
                        },
                      ],
                      staticClass: "field__move",
                      attrs: { size: "iconic", icon: "arrows-constructor" },
                    }),
                    _c("dropdown-menu", {
                      attrs: {
                        target: `field-actions-${field.id}`,
                        list: _vm.fieldActions,
                        "custom-class": "field-menu",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onAction($event, field)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("profile-field", {
                staticClass: "field__preview",
                attrs: { field: field, preview: true },
              }),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }